import React, { useState } from 'react';
import { FiChevronDown, FiSearch } from 'react-icons/fi';
import '../styles/CountryCodePicker.scss';

const countries = [
  { code: '+91', flag: '🇮🇳', name: 'India', iso2: 'IN' },
  { code: '+1', flag: '🇺🇸', name: 'United States', iso2: 'US' },
  { code: '+44', flag: '🇬🇧', name: 'United Kingdom', iso2: 'GB' },
  { code: '+61', flag: '🇦🇺', name: 'Australia', iso2: 'AU' },
  { code: '+81', flag: '🇯🇵', name: 'Japan', iso2: 'JP' },
];

const CountryCodePicker = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  
  const selectedCountry = countries.find(c => c.code === value) || countries[0];
  
  const filteredCountries = countries.filter(country =>
    country.name.toLowerCase().includes(search.toLowerCase()) ||
    country.code.includes(search)
  );

  const handleSelect = (country) => {
    onChange(country);
    setIsOpen(false);
    setSearch('');
  };

  return (
    <div className="country-picker">
      <button
        type="button"
        className="country-picker-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="country-flag">{selectedCountry.flag}</span>
        <span className="country-code">{selectedCountry.code}</span>
        <FiChevronDown />
      </button>

      {isOpen && (
        <>
          <div className="country-picker-overlay" onClick={() => setIsOpen(false)} />
          <div className="country-picker-dropdown">
            <div className="search-box">
              <FiSearch />
              <input
                type="text"
                placeholder="Search country..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            
            <div className="country-list">
              {filteredCountries.map((country) => (
                <button
                  key={country.iso2}
                  type="button"
                  className="country-item"
                  onClick={() => handleSelect(country)}
                >
                  <span className="country-flag">{country.flag}</span>
                  <span className="country-name">{country.name}</span>
                  <span className="country-code">{country.code}</span>
                </button>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default CountryCodePicker;